import React, { useEffect, useState, useCallback } from 'react';
import { Dropdown, Button, Tag, message } from 'antd';
import { DownOutlined, TeamOutlined, CheckOutlined } from '@ant-design/icons';
import api, { PLAYER_ACTIVE_TEAM_KEY } from '../../services/api';

const ACTIVE_KEY = PLAYER_ACTIVE_TEAM_KEY;

// Antes a area do jogador gravava em 'active_customer_id' (mesma chave do
// painel). No host comunidade.futezap.com.br essa chave so era usada pelo
// jogador, entao aproveita o valor antigo pra nao resetar o time escolhido.
function readStoredActive() {
  const v = localStorage.getItem(ACTIVE_KEY)
    || (window.location.hostname.startsWith('comunidade.') ? localStorage.getItem('active_customer_id') : null);
  return v ? parseInt(v, 10) : null;
}

export default function TeamSwitcher({ isMobile }) {
  const [teams, setTeams] = useState([]);
  const [activeId, setActiveIdState] = useState(readStoredActive);

  const setActive = useCallback((cid) => {
    localStorage.setItem(ACTIVE_KEY, String(cid));
    setActiveIdState(cid);
    window.dispatchEvent(new CustomEvent('active_customer_changed', { detail: { customer_id: cid } }));
  }, []);

  const load = useCallback(async () => {
    try {
      const r = await api.get('/community/auth/my-teams');
      const list = r.data?.teams || [];
      // Dedup defensivo por id (backend deveria ja usar DISTINCT, mas garante)
      const seen = new Set();
      const uniqueList = list.filter(t => {
        if (seen.has(t.id)) return false;
        seen.add(t.id);
        return true;
      });
      setTeams(uniqueList);
      // Sem time nao bloqueia mais — jogador de Comunidade pode existir
      // sem estar em time (procura peladas, mapa, cria perfil). Simplesmente
      // nao renderiza o switcher; telas que dependem de time (dashboard)
      // mostram CTA proprio.
      if (uniqueList.length === 0) return;
      const stored = readStoredActive();
      const valid = uniqueList.find(t => t.id === stored);
      if (!valid) setActive(uniqueList[0].id);
      // Valor veio da chave antiga: so persiste na nova (sem disparar evento)
      else if (!localStorage.getItem(ACTIVE_KEY)) localStorage.setItem(ACTIVE_KEY, String(stored));
    } catch (err) {
      // 401 já é tratado no api interceptor
    }
  }, [setActive]);

  useEffect(() => { load(); }, [load]);

  if (teams.length === 0) return null;

  const active = teams.find(t => t.id === activeId) || teams[0];

  if (teams.length === 1) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 8 }}>
        <span style={{ fontSize: 12, color: '#8c8c8c', fontWeight: 500 }}>Time:</span>
        <Tag color="green" icon={<TeamOutlined />} style={{ margin: 0 }}>
          {isMobile ? active.game_name.slice(0, 12) + (active.game_name.length > 12 ? '…' : '') : active.game_name}
        </Tag>
      </div>
    );
  }

  const items = teams.map(t => ({
    key: String(t.id),
    label: (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {t.id === active.id ? <CheckOutlined style={{ color: '#52c41a' }} /> : <span style={{ width: 14 }} />}
        <span>{t.game_name}</span>
      </div>
    ),
    onClick: () => {
      if (t.id === active.id) return;
      setActive(t.id);
      message.success(`Time atual: ${t.game_name}`);
      setTimeout(() => window.location.reload(), 300);
    },
  }));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <span style={{ fontSize: 12, color: '#8c8c8c', fontWeight: 500 }}>Time:</span>
      <Dropdown menu={{ items }} trigger={['click']}>
        <Button type="text" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 8px' }}>
          <TeamOutlined style={{ color: '#25D366' }} />
          <span style={{ maxWidth: isMobile ? 100 : 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 500 }}>
            {active.game_name}
          </span>
          <DownOutlined style={{ fontSize: 10 }} />
        </Button>
      </Dropdown>
    </div>
  );
}
